// extracted by mini-css-extract-plugin
export default {"root":"DraggableHTabs_root__muiBx"};